import React, { createContext, useContext, useEffect, useState } from 'react';

const AdminAuthContext = createContext({});

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (context === undefined) {
    throw new Error('useAdminAuth must be used within an AdminAuthProvider');
  }
  return context;
};

export const AdminAuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const ADMIN_PASSWORD = import.meta.env?.VITE_ADMIN_PASSWORD || 'admin123';

  useEffect(() => {
    // Check if user is already authenticated
    const authData = localStorage.getItem('adminAuth') || sessionStorage.getItem('adminAuth');
    
    if (authData) {
      try {
        const parsedAuth = JSON.parse(authData);
        if (parsedAuth?.authenticated && parsedAuth?.loginTime) {
          // Check if auth is still valid (24 hours for localStorage, session for sessionStorage)
          const loginTime = new Date(parsedAuth.loginTime);
          const now = new Date();
          const diffHours = (now - loginTime) / (1000 * 60 * 60);
          
          if (localStorage.getItem('adminAuth') && diffHours < 24) {
            setIsAuthenticated(true);
            setUser(parsedAuth);
          } else if (sessionStorage.getItem('adminAuth')) {
            setIsAuthenticated(true);
            setUser(parsedAuth);
          } else {
            // Clear expired auth
            localStorage.removeItem('adminAuth');
            sessionStorage.removeItem('adminAuth');
          }
        }
      } catch (error) {
        // Invalid auth data, clear it
        localStorage.removeItem('adminAuth');
        sessionStorage.removeItem('adminAuth');
      }
    }
    
    setLoading(false);
  }, []);

  const login = async (password, rememberMe = false) => {
    try {
      if (password === ADMIN_PASSWORD) {
        const authData = {
          authenticated: true,
          loginTime: new Date()?.toISOString(),
          username: 'admin'
        };

        // Store authentication based on remember me preference
        const storage = rememberMe ? localStorage : sessionStorage;
        storage?.setItem('adminAuth', JSON.stringify(authData));

        setIsAuthenticated(true);
        setUser(authData);
        return { success: true, error: null };
      } else {
        return { success: false, error: 'Mot de passe incorrect' };
      }
    } catch (error) {
      return { success: false, error: 'Erreur de connexion' };
    }
  };

  const logout = () => {
    localStorage.removeItem('adminAuth');
    sessionStorage.removeItem('adminAuth');
    setIsAuthenticated(false);
    setUser(null);
  };

  const value = {
    isAuthenticated,
    loading,
    user,
    login,
    logout
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export default AdminAuthContext;